module.exports = __webpack_public_path__ + "static/media/Icon-Component-History.9f8cffc6.svg";